import React from 'react';
import { Navigate } from 'react-router-dom';
import { initialUrl } from 'shared/constants/AppConst';
import { authRouteConfig } from './auth';
import Error403 from './errorPages/Error403';
import { errorPagesConfigs } from './errorPages';

import LiveTrackingPublic from './ManageLiveTracking/liveTrackingDashboard/liveTrackingPublic/index'
import { dashBoardConfigs } from './dashboards';
import { userListConfig } from './userList';
import { thirdPartyConfigs } from './thirdParty';
import { accountPagesConfigs } from './account';
import { onBordTenentConfigs } from './onBordTenent';
import { onbordCorporateConfigs } from './onboardCorporate';
import { empolyeeConfigs } from './manageEmployee';
import { MasterConfigs } from './Master';
import { DriverShiftConfigs } from './DriverShift';
import { DepartmentConfigs } from './onboardCorporate/CorporateMaster/ManageDepartment';
import { SpecialEmployeeConfigs } from './onboardCorporate/CorporateMaster/SpecialEmployee';
// import {VehiclecostConfigs} from './VehicleTypeCost';
import { PenaltyConfigs } from './Penalty';
import { GpsConfig } from './Master/Gps-Vendor/index';
import { GpsListConfig } from './Master/Gps-list/index';
import { EmployeeCategory } from './onboardCorporate/CorporateMaster/ManageEmployeeCategory';
import { DriverConfigs } from './ManageDrivers';
import { VehicleConfigs } from './ManageVehicles';
import { VendorConfigs } from './ManageVendor';
import { ShiftsConfigs } from './onboardCorporate/CorporateMaster/ManageShifts';
import { DesignationConfigs } from './onboardCorporate/CorporateMaster/ManageDesignation';
import { EscortConfigs } from './ManageEscort';
import { SiteOfficeConfigs } from './ManagesiteOffice';
import { BusinessUnitConfigs } from './onboardCorporate/CorporateMaster/Manage BusinessUnit';
import { HolidayConfigs } from './onboardCorporate/CorporateMaster/Manageholidays';
import { home } from './home';
import { NodalPointConfigs } from './NodelPoint';
import { RoutingConfigs } from './ManageRoutes';
import { mapplsConfigs } from './ManageMappls';
import { liveTracking } from './ManageLiveTracking';
import { rosterConfigs } from './Roster';
import { vTypeConfigs } from './VTypeCost';
import { ShiftConfigs } from './ManageShifts';
import { LiveTripConfig } from './onboardCorporate/CorporateMaster/LiveTrip/index';
import { LeaveConfig } from './Leave';
import { ShiftsTypeConfigs } from './onboardCorporate/CorporateMaster/Manage ShiftType/index';
import { AnnouncementConfigs } from './onboardCorporate/CorporateMaster/Announcement/index';
// import {IncedentManagementConfig} from './Incedent-management/index';
import { ComplianceConfig } from './compliances/index';
import { AdhocTripConfig } from './AdhocTrip/index';
import { EscortAgencysConfigs } from './onboardCorporate/CorporateMaster/ManageEscortAgency/index';
import { UserManagementConfig } from './User-Management';
import { ReportConfigs } from './Reports';
import { FeedBackConfigs } from './FeedBack';
import {FeedbacksConfigs} from './Feedbacks';
import { IVRConfig } from './IVR';
import { BillingsConfigs } from './Billings';
import { TrainingVideoConfig } from './Training Video';
import { InvoicingConfig } from './Invoicing';
import { CustomerPageConfig } from './CustomerPage/index';
import { FuelTrackConfigs } from './FuelTracking/index';
import { IncidentConfig } from './Incident-Management/index';
import { YourRideConfigs } from './YourRide';
import { DriversShiftConfigs } from '../pages/DriversShift/index';
import { UserConfigs } from './EtravelMate User/index';
// import {VendorUserConfigs} from './Vendor-User-Management/index';

import { DriverConsentConfigs } from './DriverConsent/index';
import { DriverAttendenceConfigs } from './DriverAttendence/index';
import { notificationsConfigs } from './Notifications/index';
import { FuelPriceConfig , CorporateFuelPriceConfig} from './FuelPrice/index';
import {CabIdConfigs} from './onboardCorporate/CorporateMaster/ManageCabId';
import { AssociateConfig } from './Association/index';
import { NewGpsListConfig } from './GPS_VENDOR/index';
import { POCMapConfig } from './POCMap';
import { VehicleDriverConfig } from './Vehicle-Driver/index';
import { HistoryConfig } from './History/index';
import { BillingMNoduleConfig } from './ManageBilling';


// TEMPORARY — remove this import to disable the Fair Cab Simulator feature
import {FairCabSimulatorConfig} from './FairCabSimulator';
import {ParkingManagementConfigs} from './parkingManagement';
const authorizedStructure = {
  fallbackPath: '/home',
  unAuthorizedComponent: <Error403 />,
  routes: [
    ...IVRConfig,
    ...HistoryConfig,
    ...notificationsConfigs,
    ...InvoicingConfig,
    ...MasterConfigs,
    ...BillingsConfigs,
    ...DriversShiftConfigs,
    ...onBordTenentConfigs,
    ...onbordCorporateConfigs,
    ...dashBoardConfigs,
    ...accountPagesConfigs,
    ...thirdPartyConfigs,
    ...userListConfig,
    ...home,
    ...empolyeeConfigs,
    ...DepartmentConfigs,
    ...DriverConsentConfigs,
    ...DriverConfigs,
    ...ShiftConfigs,
    ...VehicleConfigs,
    ...VendorConfigs,
    ...ShiftsConfigs,
    ...EscortConfigs,
    ...SiteOfficeConfigs,
    ...HolidayConfigs,
    ...NodalPointConfigs,
    ...RoutingConfigs,
    ...mapplsConfigs,
    ...liveTracking,
    ...rosterConfigs,
    ...SpecialEmployeeConfigs,
    ...DesignationConfigs,
    ...EmployeeCategory,
    // ...VehiclecostConfigs,
    ...PenaltyConfigs,
    ...GpsConfig,
    ...GpsListConfig,
    ...vTypeConfigs,
    ...BusinessUnitConfigs,
    ...LiveTripConfig,
    ...LeaveConfig,
    ...ShiftsTypeConfigs,
    // ...IncedentManagementConfig,
    ...AnnouncementConfigs,
    ...ComplianceConfig,
    ...AdhocTripConfig,
    ...EscortAgencysConfigs,
    ...UserManagementConfig,
    ...ReportConfigs,
    ...FeedBackConfigs,
    ...FeedbacksConfigs,
    ...TrainingVideoConfig,
    ...CustomerPageConfig,
    ...FuelTrackConfigs,
    ...IncidentConfig,
    ...YourRideConfigs,
    ...UserConfigs,
    // ...VendorUserConfigs,
    ...DriverAttendenceConfigs,
    ...FuelPriceConfig,
    ...CorporateFuelPriceConfig,
    ...AssociateConfig,
    ...NewGpsListConfig,
    ...POCMapConfig,
    ...VehicleDriverConfig,
    // billing module configs
    ...BillingMNoduleConfig,
    // TEMPORARY — remove this line to disable the Fair Cab Simulator feature
    ...FairCabSimulatorConfig,
    ...CabIdConfigs,
    ...ParkingManagementConfigs,
  ],
};

const unAuthorizedStructure = {
  fallbackPath: initialUrl,
  routes: authRouteConfig,
};
const anonymousStructure = {
  routes: errorPagesConfigs.concat([
    {
      path: '/public/live-tracking/:token',
      element: <LiveTrackingPublic />,
    },
    {
      path: '/',
      element: <Navigate to={initialUrl} />,
    },
    {
      path: '*',
      element: <Navigate to='/error-pages/error-404' />,
    },
  ]),
};

export { authorizedStructure, unAuthorizedStructure, anonymousStructure };
